module.exports = __webpack_public_path__ + "static/media/AB_K11_6.a2043257.jpg";